import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

const PLACEHOLDER_ORIGIN = 'https://app.invalid'

// Only a path within the app: `from` comes from the URL, so anything else would make the back link an
// open redirect. Parsing it as browsers do catches the tricks a pattern misses: they drop tabs and
// newlines and read `\` as `/`, so `/\t/host` and `/\host` both lead to another host.
const isValidFromPath = (from: unknown): from is string => {
  if (typeof from !== 'string' || !from.startsWith('/') || from.includes('/settings')) return false
  try {
    return new URL(from, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN
  } catch {
    // A path the URL parser rejects (such as `/\[`) can't be followed safely either.
    return false
  }
}

export const useOriginalPath = (isSettingsDashboard: boolean) => {
  const router = useRouter()
  const originalPathRef = useRef<string | null>(null)

  if (isSettingsDashboard && !originalPathRef.current) {
    const from = router.query.from
    if (isValidFromPath(from)) {
      originalPathRef.current = from
    } else {
      originalPathRef.current = '/'
    }
  }

  useEffect(() => {
    if (isSettingsDashboard) {
      const from = router.query.from
      if (isValidFromPath(from)) {
        originalPathRef.current = from
      }
    }
  }, [isSettingsDashboard, router.query.from])

  return originalPathRef.current || '/'
}
